/**
 * remark Group
 * @param fb : FormBuilder
 */
export function remarkGroup (fb: any) {
    return fb.array([
        remarkGroupInArray(fb)
    ]);
}

export function remarkGroupInArray (fb: any) {
    return fb.group({
        text: fb.control()
    });
}
